(function () {
  'use strict';

  // Time each line holds at center before the wheel advances. The dwell between
  // ticks is the "pause"; the CSS transition handles the slide between slots.
  const STEP_MS = 2600;

  function slotFor(offset) {
    if (offset === 0) return 'active';
    if (offset === -1) return 'prev';
    if (offset === 1) return 'next';
    return 'hidden';
  }

  // Map every line to a slot relative to the active index. Only the immediate
  // neighbours (offset -1 / +1) show as prev / next; the rest are hidden above.
  // The wrap keeps the wheel circular, so it behaves the same for 3 lines or 100.
  function render(lines, active, prev) {
    const count = lines.length;
    lines.forEach((line, i) => {
      let offset = i - active;
      if (offset > count / 2) offset -= count;
      if (offset < -count / 2) offset += count;

      const pos = slotFor(offset);

      // A line becomes "next" only by wrapping up-and-over from the top. Snap it
      // to the bottom entry point with no transition (invisible) first, so it
      // rises into view instead of sliding all the way down across the window.
      if (pos === 'next' && prev[i] !== 'next') {
        line.style.transition = 'none';
        line.dataset.pos = 'enter';
        line.getBoundingClientRect(); // force reflow so the snap commits
        line.style.transition = '';
      }

      line.dataset.pos = pos;
      prev[i] = pos;
    });
  }

  function setup(root) {
    const lines = Array.from(root.querySelectorAll('.c-about__manifesto-line'));
    if (lines.length === 0) return;

    /* Respect reduced-motion: no auto-rotation (WCAG 2.2.2 / 2.3.3). The CSS
       reduced-motion block un-stacks every line into a static, fully-readable
       list, so no content is hidden behind the (now-stopped) wheel. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const prev = [];
    let active = 0;
    render(lines, active, prev);

    if (lines.length > 1) {
      setInterval(() => {
        active = (active + 1) % lines.length;
        render(lines, active, prev);
      }, STEP_MS);
    }
  }

  function init() {
    document.querySelectorAll('[data-manifesto]').forEach(setup);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
